const str = '';
const dateTimeStr = new Date()?.toISOString();

export const coinModelGet = ({
    buildingId = '', 
    userId = '',
}) => {
    return {
        buildingId: buildingId,
        countryId: str,
        codeA: str,
        codeN: str,
        created: dateTimeStr,
        description: str,
        userId: userId,
    }
};